import type {PartialOptions} from "../../stem-core/ui/UIBase";
import {UI} from "../../stem-core/ui/UIBase";
import {styleRule, StyleSheet} from "../../stem-core/ui/Style";
import {Messages} from "../Messages";
import {isFacebookBrowser} from "../Utils";
import {BLINK_PAY_URL} from "../Constants";
import {PanelLink} from "../panel/panel-elements/PanelLink.jsx";
import {registerStyle} from "../../stem-core/ui/style/Theme";

class MerchantUserResourcesAccessLinkStyle extends StyleSheet {
    @styleRule
    container = {
        display: "inline-block",
        marginLeft: 8,
        ">:last-child": {
            display: "inline-block",
            marginLeft: 8,
        }
    }
}

interface MerchantUserResourcesAccessLinkOptions {
    extraResourcesCount?: number;
}

@registerStyle(MerchantUserResourcesAccessLinkStyle)
class MerchantUserResourcesAccessLink extends UI.Element<MerchantUserResourcesAccessLinkOptions> {
    getDefaultOptions(): PartialOptions<MerchantUserResourcesAccessLink> {
        return {
            extraResourcesCount: null,
        };
    }

    render() {
        const {extraResourcesCount} = this.options;
        //TODO @auth insanely complex
        return [
            Messages.or,
            <PanelLink
                href={BLINK_PAY_URL + "/login"}
                newTab
                rel="opener"
            >
                {Messages.merchantUserResourcesAccessLink(extraResourcesCount)}
            </PanelLink>
        ];
    }
}

export function MakeMerchantUserResourcesAccessLink(extraResourcesCount: number) {
    if (isFacebookBrowser()) { // TODO: Maybe support these later.
        return null;
    }

    return (extraResourcesCount > 0) && <MerchantUserResourcesAccessLink extraResourcesCount={extraResourcesCount}/>;
}
